// Boostrap Components
import JQuery from "jquery";
import "bootstrap";

JQuery(document).on("turbolinks:load cable-ready:after-morph", () => {
  JQuery('[data-toggle="tooltip"]').tooltip();
});
